// test1602
(1602 && 0);
